// extracted by mini-css-extract-plugin
export default {"card":"DocumentCard_card__-DGg3","link":"DocumentCard_link__utjKH","image":"DocumentCard_image__eHE0t","title":"DocumentCard_title__HFt9l"};